import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';

@Component({
  selector: 'app-invite-user',
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.scss']
})
export class InviteUserComponent implements OnInit {

  @Input() userRoles: Array<string>;
  @Output() onCreateAdminEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('addAdminForm', { static: true }) public addAdminForm: NgForm;
  adminFormData: any = {};

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
  }

  onCreateAdmin(form: NgForm) {
    console.log("admin form data::", this.adminFormData);
    if (form.valid) {
      if (this.adminFormData.role) {
        const requestPayload = [{
          "roles": [this.adminFormData.role],
          "name": this.adminFormData.name,
          "username": this.adminFormData.adminEmail,
          "phone": this.adminFormData.adminPhone,
          "image": this.adminFormData.image
        }];
        this.onCreateAdminEmitter.emit(JSON.parse(JSON.stringify(requestPayload)));
      } else {
        this.toast.showWarning("Please select role");
      }
    }
  }

  uploadFleetB2BLogo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'user/' + this.authService.loggedInUser.providerId);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.adminFormData['image'] = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadFleetB2BLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toast.showError(error.error.message);
          else this.toast.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  changeuploadFleetB2BLogoClicked() {
    document.getElementById("uploadUserLogoInput").click();
  }

  resetAddAdminForm() {
    this.addAdminForm.resetForm();
    this.adminFormData = {};
  }

}
